<div class="container-fluid mt-4 px-3 collection-summary-page">
    <div class="collection-header">
      <h3 class="mb-0">Collection Summary</h3>
      <a class="collection-back btn btn-outline-secondary btn-sm" routerLink="/internal-dashboard">
        <i class="bi bi-arrow-left me-1"></i>Back to Dashboard
      </a>
    </div>

    <!-- Filter UI -->
    <div class="collection-filters d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3">
      <div class="filter-field d-flex align-items-center gap-2">
        <label for="salesRepFilter" class="form-label mb-0 fw-semibold text-secondary">
          <i class="bi bi-person-badge-fill me-1"></i>Filter by Sales Rep:
        </label>
        <select id="salesRepFilter"
                class="form-select form-select-sm w-auto"
                [(ngModel)]="selectedSalesRep"
                (change)="filterBySalesRep()">
          <option value="">All</option>
          <option *ngFor="let rep of salesReps" [value]="rep">{{ rep }}</option>
        </select>
      </div>

      <div class="filter-field search-field d-flex align-items-center gap-2 flex-grow-1" style="max-width: 480px;">
        <label for="locationSearch" class="form-label mb-0 fw-semibold text-secondary">
          <i class="bi bi-geo-alt-fill me-1"></i>Search location/address:
        </label>
        <input id="locationSearch"
               type="search"
               class="form-control form-control-sm"
               list="locationOptions"
               [(ngModel)]="searchTerm"
               (input)="onSearchChange()"
               placeholder="Start typing a location name or address" />
        <datalist id="locationOptions">
          <option *ngFor="let option of locationSuggestions" [value]="option"></option>
        </datalist>
      </div>

      <div *ngIf="selectedSalesRep" class="text-muted small">
        Showing collections for: <strong>{{ selectedSalesRep }}</strong>
      </div>
    </div>
    <!-- Month Filter Buttons -->
    <div class="month-strip d-flex gap-2 flex-wrap mb-3">
      <button
        *ngFor="let month of availableMonths"
        (click)="selectedMonth = month; filterByMonth()"
        [class.active]="selectedMonth === month"
        class="month-button"
      >
        {{ month + '-01' | date: 'MMMM y' }}
      </button>

    </div>
    <div *ngIf="selectedMonth && !searchTerm" class="mb-2">
  <span class="text-muted small">Showing collections for <strong>{{ selectedMonth + '-01' | date: 'MMMM y' }}</strong></span>
</div>
<div *ngIf="searchTerm" class="mb-2">
  <span class="text-muted small">Showing all months matching "<strong>{{ searchTerm }}</strong>"</span>
</div>
<!-- Export Buttons -->
<div *ngIf="selectedMonth" class="mb-3">
  <button class="btn btn-outline-danger btn-sm me-2" (click)="downloadPdf()">
    <i class="bi bi-file-earmark-pdf-fill me-1"></i>Export PDF
  </button>
  <button class="btn btn-outline-success btn-sm" (click)="downloadExcel()">
    <i class="bi bi-file-earmark-excel-fill me-1"></i>Export Excel
  </button>
</div>




    <!-- Table -->
    <div class="table-wrapper" #collectionTableWrapper>
      <table class="table table-striped table-bordered align-middle collection-table">
        <thead class="table-dark">
          <tr>
            <th class="location-col">Location</th>
            <th>Date</th>
            <th>Previous Date</th>
            <th>Days Gap</th>
            <th>Address</th>
            <th>Sales Rep</th>
            <th># Boards</th>
            <th>Cash In</th>
            <th>Cash Out</th>
            <th>Gross</th>
            <th>Split %</th>
            <th class="net-col">Net</th>
            <th class="received-col">Received</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let summary of summaries; let i = index">
            <tr class="collection-row">
              <td class="location-col">{{ summary.locationName }}</td>
              <td>{{ summary.currentDate | date: 'mediumDate' }}</td>
              <td>{{ summary.previousDate | date: 'mediumDate' }}</td>
              <td>{{ getDaysBetween(summary.previousDate, summary.currentDate) }} days</td>
              <td>{{ getAddressLine(summary) || '-' }}</td>

              <td>{{ summary.salesRepName || '-' }}</td>
              <td>{{ summary.numberOfBoards }}</td>
              <td>{{ summary.totalCashIn | currency }}</td>
              <td>{{ summary.totalCashOut | currency }}</td>
<td>
  <span>{{ (summary.newGross ?? summary.totalGross) | currency }}</span>

  <!-- Tooltip ONLY if there's a newGross different from totalGross -->
  <i
    *ngIf="summary.newGross && summary.newGross !== summary.totalGross"
    class="bi bi-info-circle ms-1 text-primary"
    [title]="'Adjusted from ' + (summary.totalGross | currency) + ' + carryover ' + (summary.carryoverGross | currency)">
  </i>
</td>


              <td>{{ summary.splitPercentage * 100 }}%</td>
<td class="text-end net-col">
  {{ summary.collectorShare | currency }}
  <i *ngIf="summary.carriedCollectorShare > 0"
     class="bi bi-info-circle"
     placement="top"
     [ngbTooltip]="'Previous unpaid balance: ' + (summary.carriedCollectorShare | currency) +
                   '. New balance: ' + ((summary.collectorShare - summary.carriedCollectorShare) | currency) +
                   '. Total collector share: ' + (summary.collectorShare | currency)">
  </i>
</td>



              <td class="received-col">
                <input
                  type="number"
                  class="form-control form-control-sm"
                  [(ngModel)]="summary.amountReceived"
                  [ngClass]="{ 'bg-danger text-white': summary.amountReceived === 0 }"
                  [attr.title]="summary.amountReceived === 0 ? 'Gross is negative or location has not paid' : null"
                  min="0"
                />
              </td>
              <td class="actions-cell">
                <div class="collection-actions">
                  <button
                    class="btn btn-sm btn-success"
                    type="button"
                    (click)="saveAmountReceived(summary)"
                    title="Save amount received"
                    aria-label="Save amount received">
                    Save
                  </button>
                  <button class="btn btn-sm btn-outline-primary" type="button" (click)="toggleExpand(i)">
                    {{ expandedIndex === i ? 'Hide' : 'Show' }}
                  </button>

                  <button
                    class="btn btn-sm btn-outline-warning"
                    type="button"
                    (click)="openEditModal(summary)"
                    title="Edit collection"
                    aria-label="Edit collection">
                    Edit
                  </button>
                  <button
                    *ngIf="isRootUser"
                    class="btn btn-sm btn-danger"
                    type="button"
                    (click)="deleteCollection(summary)"
                    title="Delete collection"
                    aria-label="Delete collection">
                    Delete
                  </button>
                  <button
                    class="btn btn-sm btn-outline-danger"
                    type="button"
                    (click)="exportPdf(summary.id)"
                    title="Export collection PDF"
                    aria-label="Export collection PDF">
                    PDF
                  </button>

                </div>
              </td>
            </tr>

           <tr *ngIf="expandedIndex === i" class="collection-expanded-row">
              <td [attr.colspan]="14">
               <div [id]="'collection-summary-' + summary.id" class="game-summary-wrapper">
                  <div class="game-summary-header">
                    <strong>Game Summary</strong>
                    <button class="btn btn-sm btn-outline-secondary" type="button" (click)="toggleExpand(i)">
                      Close
                    </button>
                  </div>
                  <table class="table table-sm table-bordered game-summary-table">
                  <thead class="table-light">
                    <tr>
                      <th class="game-col">Game</th>
                      <th>Cash In</th>
                      <th>Cash Out</th>
                      <th>Gross</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let game of summary.gameSummaries">
                      <td class="game-col">{{ game.gameName }}</td>
                      <td>{{ game.cashInDelta | currency }}</td>
                      <td>{{ game.cashOutDelta | currency }}</td>
                      <td>{{ game.gross | currency }}</td>
                    </tr>
                    <tr class="fw-bold bg-light">
                      <td class="game-col">Total</td>
                      <td>{{ getTotalCashIn(summary.gameSummaries) | currency }}</td>
                      <td>{{ getTotalCashOut(summary.gameSummaries) | currency }}</td>
                      <td>{{ getTotalGross(summary.gameSummaries) | currency }}</td>
                    </tr>
                  </tbody>
                </table>
                </div>
              </td>
            </tr>
          </ng-container>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="6" class="text-end"><strong>Grand Totals:</strong></td>
            <td><strong>{{ getTotalBoards() }}</strong></td>
            <td><strong>{{ getOverallTotalCashIn() | currency }}</strong></td>
            <td><strong>{{ getOverallTotalCashOut() | currency }}</strong></td>
            <td>
              <div><strong>{{ getOverallTotalGross() | currency }}</strong></div>
              <div *ngIf="getTotalCarryoverGross() > 0" class="small text-info">
                (Carried: {{ getTotalCarryoverGross() | currency }})
              </div>
            </td>
            <td></td>
            <td>
              <div><strong>{{ getOverallTotalNet() | currency }}</strong></div>
              <div *ngIf="getTotalCarriedCollectorShare() > 0" class="small text-warning">
                (Unpaid: {{ getTotalCarriedCollectorShare() | currency }})
              </div>
            </td>
            <td><strong>{{ getOverallTotalReceived() | currency }}</strong></td>
            <td></td>
          </tr>
        </tfoot>

      </table>
    </div>
    <div class="d-flex justify-content-center my-3" *ngIf="hasMore">
      <button class="btn btn-outline-primary" (click)="loadNextPage()" [disabled]="isLoadingPage">
        {{ isLoadingPage ? 'Loading...' : 'Load more collections' }}
      </button>
    </div>
  </div>

  <!-- Edit Collection Modal -->
  <div #editModal class="modal fade" id="editCollectionModal" tabindex="-1" aria-labelledby="editModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="editModalLabel">Edit Collection</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body" *ngIf="selectedSummary">
          <p><strong>Location:</strong> {{ selectedSummary.locationName }}</p>
          <div class="mb-3">
            <label class="form-label">Split Percentage</label>
            <input type="number" class="form-control" [(ngModel)]="selectedSummary.splitPercentage"
              (ngModelChange)="updateCollectorShare()" step="0.01" min="0" max="1" />
          </div>
          <div class="mb-3">
            <label class="form-label">Amount Received</label>
            <input type="number" class="form-control" [(ngModel)]="selectedSummary.amountReceived" min="0" />
          </div>
          <div class="mb-3">
            <label class="form-label">Collector Share (auto)</label>
            <input type="text" class="form-control" [value]="selectedSummary.collectorShare | currency" disabled />
          </div>
          <div *ngIf="selectedSummary.carryoverGross || selectedSummary.carriedCollectorShare" class="alert alert-info">
          <div *ngIf="selectedSummary.carryoverGross">
            <i class="bi bi-arrow-repeat me-1"></i>
            <strong>Carryover Gross:</strong> {{ selectedSummary.carryoverGross | currency }}
          </div>
          <div *ngIf="selectedSummary.carriedCollectorShare">
            <i class="bi bi-piggy-bank me-1"></i>
            <strong>Unpaid From Previous:</strong> {{ selectedSummary.carriedCollectorShare | currency }}
          </div>
        </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-primary" (click)="saveEdit()">Save</button>
        </div>
      </div>
    </div>
  </div>

